/*
実践プロジェクトの札の題と、学習パスの区切りの題を、画面の日本語に寄せる。
題そのものは学習サイトのデータが正本なので、出すときだけ直す
*/

/**
 * 学習パスの区切りの題 (DB の milestone) を画面の日本語に寄せる。題そのものは学習パスが正本なので、出すときだけ直す。
 * 「Phase 2 開始 Web開発コア - Backend」は「フェーズ 2 Web開発コア (バックエンド)」、「実践PJ1開始 ECサイト構築」は
 * 「実践プロジェクト 1 の開始 (ECサイト構築)」(回 5 の M11。発表会の札と同じ「フェーズ」にそろえる)
 */
const EN_WORDS: [RegExp, string][] = [
  [/\bBackend\b/g, "バックエンド"],
  [/\bFrontend\b/g, "フロントエンド"],
];
export function jaPathTitle(title: string): string {
  let out = title.trim();
  const project = out.match(/^実践\s*PJ\s*(\d+)\s*開始\s*(.*)$/);
  if (project) out = project[2] ? `実践プロジェクト ${project[1]} の開始 (${project[2]})` : `実践プロジェクト ${project[1]} の開始`;
  out = out.replace(/^Phase\s*(\d+)\s*(?:開始\s*)?/, "フェーズ $1 ");
  out = out.replace(/\s+-\s+([^-]+)$/, " ($1)");
  for (const [re, ja] of EN_WORDS) out = out.replace(re, ja);
  return out.trim();
}

/** 題の「 — 」より後ろを副題として別の行に出す (行頭に「—」や「+」が来ないように。回 5 の M10) */
export function splitProjectTitle(title: string): { main: string; sub: string | null } {
  const at = title.indexOf(" — ");
  if (at < 0) return { main: title, sub: null };
  return { main: title.slice(0, at), sub: title.slice(at + 3) };
}
